import styled, { css } from 'styled-components'
import { COLORS } from 'consts/colors'

// Shared look of the small square overlay action buttons (Resize / Enhance /
// Delete). Positioning is owned by `ActionsRow`, not the button, so every action
// button shares this exact appearance.
const actionButtonBase = css`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0;
  border: 1px solid ${COLORS.borderColor};
  border-radius: 4px;
  background-color: ${COLORS.white};
  cursor: pointer;
  transition: background-color 0.15s ease;

  &:hover {
    background-color: ${COLORS.primaryExtraLight};
  }
`

export const ActionButton = styled.button<{ $isActive?: boolean }>`
  ${actionButtonBase}
  ${({ $isActive }) =>
    $isActive &&
    css`
      background-color: ${COLORS.primaryExtraLight};
    `}
`
